import React, { useEffect, useState } from "react";
import { Fingerprint, MapPin } from "lucide-react";
import * as api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useData } from "@/hooks/useData";
import { usePunchClock } from "@/hooks/usePunchClock";
import { Card, DefinitionList, SectionCard, StatusBadge, TableCard } from "@/components/ui";
import { AttendanceTable, PunchCard } from "@/components/hrms";
import { hours, time } from "@/lib/format";

function LiveClock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const id = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(id); }, []);
  return (
    <Card className="p-5 flex flex-col justify-center">
      <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-slate-400">
        {now.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}
      </p>
      <p className="text-4xl font-extrabold text-brand-blue mt-2 tabular-nums tracking-tight">{now.toLocaleTimeString("en-GB", { hour12: false })}</p>
      <p className="text-xs text-slate-500 mt-3 flex items-center gap-1.5"><MapPin size={13} className="text-brand-orange" /> Dubai Office, Business Bay</p>
      <p className="text-[11px] text-slate-400 mt-0.5">GPS 25.1972° N, 55.2744° E</p>
    </Card>
  );
}

export default function PunchInOut() {
  const { user } = useAuth();
  const empId = user.employee_id;
  const { data: history, reload } = useData(() => api.attendance.list({ employeeId: empId }), [empId]);
  const clock = usePunchClock(empId, reload);
  const t = clock.today;

  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <LiveClock />
        <PunchCard clock={clock} />
        <SectionCard title="Today">
          <DefinitionList rows={[
            { label: "Punch in", value: <span className="font-mono">{time(t?.punch_in)}</span> },
            { label: "Punch out", value: <span className="font-mono">{time(t?.punch_out)}</span> },
            { label: "Hours", value: hours(t?.working_hours) },
            { label: "Status", value: t ? <StatusBadge status={t.status} /> : "—" },
          ]} />
          <div className="neu-inset mt-4 p-3 flex items-center gap-2.5 text-[11px] text-slate-500">
            <Fingerprint size={16} className="text-brand-blue shrink-0" />
            <span>Biometric device <code className="font-mono text-brand-blue">BIO-DXB-001</code> isn't connected in the demo.</span>
          </div>
        </SectionCard>
      </div>

      <TableCard heading="Recent attendance" aside="Last 10 working days">
        <AttendanceTable records={(history || []).slice(0, 10)} />
      </TableCard>
    </>
  );
}
